import script from "./PartnerProjectRejectForm.vue?vue&type=script&setup=true&lang=js"
export * from "./PartnerProjectRejectForm.vue?vue&type=script&setup=true&lang=js"

import "./PartnerProjectRejectForm.vue?vue&type=style&index=0&id=e0254dde&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e0254dde"]])

export default __exports__